import { Component, input, signal, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import RutFormatter from './formatters/rut';

const FORMATTERS: { [key: string]: any } = {
  "rut": RutFormatter,
}

@Component({
  selector: 'app-capital-input',
  imports: [],
  templateUrl: './capital-input.html',
  styleUrl: './capital-input.scss',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CapitalInput),
      multi: true
    }
  ]
})
export class CapitalInput implements ControlValueAccessor {
  placeholder = input<string>("");
  type = input<string>("text");
  formatter = input<string>("");
  validator = input<any>(() => true);

  isFocused: any = false;
  public isValid = signal(false);
  
  value: string = '';
  isDisabled = false;
  isInitialLoad = true;
  
  private onChange: (value: string) => void = () => {};
  private onTouched: () => void = () => {};

  writeValue(value: string): void {
    this.value = value || '';
    // Desactivar flag después del primer render
    if (this.isInitialLoad && this.value) {
      setTimeout(() => {
        this.isInitialLoad = false;
      }, 0);
    }
  }

  registerOnChange(fn: (value: string) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.isDisabled = isDisabled;
  }

  onInput(event: Event) {
    if (FORMATTERS[this.formatter()])
      FORMATTERS[this.formatter()].onInput(event);

    const value = (event.target as HTMLInputElement)?.value;
    this.value = value;
    this.isValid.set(this.validator()(value));
    this.onChange(value);
  }

  onKeyDown(event: KeyboardEvent) {
    if (FORMATTERS[this.formatter()])
      FORMATTERS[this.formatter()].onKeyDown(event);
  }

  onBlur(): void {
    this.isFocused = false;
    this.onTouched();
  }

}
